/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateCompanyIdentityProviderRequestFromJSON(json) {
    return StreemApiUpdateCompanyIdentityProviderRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateCompanyIdentityProviderRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'groupingId': !exists(json, 'grouping_id') ? undefined : json['grouping_id'],
    };
}
export function StreemApiUpdateCompanyIdentityProviderRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'provider': value.provider,
        'grouping_id': value.groupingId,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiUpdateCompanyIdentityProviderRequestProvider;
(function (StreemApiUpdateCompanyIdentityProviderRequestProvider) {
    StreemApiUpdateCompanyIdentityProviderRequestProvider["COGNITO"] = "IDENTITY_PROVIDER_COGNITO";
    StreemApiUpdateCompanyIdentityProviderRequestProvider["FUSIONAUTH"] = "IDENTITY_PROVIDER_FUSION_AUTH";
    StreemApiUpdateCompanyIdentityProviderRequestProvider["INVALID"] = "IDENTITY_PROVIDER_INVALID";
})(StreemApiUpdateCompanyIdentityProviderRequestProvider || (StreemApiUpdateCompanyIdentityProviderRequestProvider = {}));
//# sourceMappingURL=StreemApiUpdateCompanyIdentityProviderRequest.js.map